import api from '@app/api'

import type { ResponseDto } from '@app/api/dtos'
import type { DefaultParams } from '@app/api/types'
import type {
  TranslationsConfigClusterDto,
  TranslationsConfigCompetitorsDto,
  TranslationsConfigDto,
  TranslationsConfigMonitoringTypeDto
} from './dtos'
import type {
  DeleteTranslationsClustersData,
  DeleteTranslationsConfigCompetitorData,
  DeleteTranslationsMonitoringTypesData,
  PatchTranslationsCompetitorsData,
  PostTranslationsClustersData,
  PostTranslationsConfigCompetitorsData,
  PostTranslationsConfigMonitoringTypesData
} from './types'

const URL = '/translations/config/'

export const getTranslationsConfig = async (): Promise<TranslationsConfigDto> => {
  const response = await api.get<TranslationsConfigDto>(URL)
  return response.data
}

export const getTranslationsConfigCompetitors = async (
  params: DefaultParams
): Promise<ResponseDto<TranslationsConfigCompetitorsDto>> => {
  const url = `${URL}competitors/`
  const response = await api.get<ResponseDto<TranslationsConfigCompetitorsDto>>(url, { params })
  return response.data
}

export const getTranslationsConfigMonitoringTypes = async (
  params: DefaultParams
): Promise<ResponseDto<TranslationsConfigMonitoringTypeDto>> => {
  const url = `${URL}monitoring-types/`
  const response = await api.get<ResponseDto<TranslationsConfigMonitoringTypeDto>>(url, { params })
  return response.data
}

export const getTranslationsConfigClusters = async (
  params: DefaultParams
): Promise<ResponseDto<TranslationsConfigClusterDto>> => {
  const url = `${URL}clusters/`
  const response = await api.get<ResponseDto<TranslationsConfigClusterDto>>(url, { params })
  return response.data
}

export const patchTranslationsConfig = async (
  data: PatchTranslationsCompetitorsData
): Promise<TranslationsConfigDto> => {
  const response = await api.patch<TranslationsConfigDto>(URL, data)
  return response.data
}

export const postTranslationsConfigCompetitors = async (data: PostTranslationsConfigCompetitorsData): Promise<void> => {
  const url = `${URL}competitors/`
  await api.post(url, data)
}

export const deleteTranslationsConfigCompetitor = async ({
  competitorSapId
}: DeleteTranslationsConfigCompetitorData): Promise<void> => {
  const url = `${URL}competitors/${competitorSapId}/delete`
  await api.delete(url)
}

export const deleteTranslationsMonitoringTypes = async ({
  monitoringTypeSapId
}: DeleteTranslationsMonitoringTypesData): Promise<void> => {
  const url = `${URL}monitoring-types/${monitoringTypeSapId}/delete`
  await api.delete(url)
}

export const postTranslationsConfigMonitoringTypes = async (
  data: PostTranslationsConfigMonitoringTypesData
): Promise<void> => {
  const url = `${URL}monitoring-types/`
  await api.post(url, data)
}

export const deleteTranslationsClusters = async ({ clusterSapId }: DeleteTranslationsClustersData): Promise<void> => {
  const url = `${URL}clusters/${clusterSapId}/delete`
  await api.delete(url)
}

export const postTranslationsClusters = async (data: PostTranslationsClustersData): Promise<void> => {
  const url = `${URL}clusters/`
  await api.post(url, data)
}
